import { createFileRoute } from '@tanstack/react-router';
import { listGeometriesInfiniteOptions } from '@/hooks/useDashboardGeometries';
import { useDiagnosisLibrary } from '@/hooks/useDiagnosisLibrary';
import { DiagnosisLibraryPanel } from './-components/DiagnosisLibraryPanel';

function DiagnosisLibraryPage() {
  const lib = useDiagnosisLibrary();
  return (
    <div className="h-full flex-1 overflow-hidden">
      <DiagnosisLibraryPanel
        items={lib.items}
        isLoading={lib.isLoading}
        error={lib.error}
        hasNextPage={lib.hasNextPage}
        isFetchingNextPage={lib.isFetchingNextPage}
        onLoadMore={() => void lib.fetchNextPage()}
      />
    </div>
  );
}

export const Route = createFileRoute('/_app/diagnosis/')({
  // Warm the first page of geometries (shares the cache entry with the MeshGen
  // dashboard; each row carries its own diagnosis summary, so this is the only
  // request the library needs). Best-effort: on failure the component's own
  // query owns retries and error UI.
  loader: async ({ context: { queryClient } }) => {
    await queryClient
      .ensureInfiniteQueryData(listGeometriesInfiniteOptions())
      .catch(() => undefined);
  },
  component: DiagnosisLibraryPage,
});
